import { FolderTrackingStepCustomization } from './folder-tracking-step-customization';

export class FolderTrackingCustomization {
    public id: number;
    public organizationId: string;
    public viewId: number;
    public title: string;
    public headerText: string;
    public footerText: string;
    public headerAttributes: number[];
    public footerAttributes: number[];
    public stepCustomizations: FolderTrackingStepCustomization[];

    /**
     * Retourne une instance de FolderTrackingCustomization à partir d'une instance de Any.
     * @param other : Instance de any.
     * @returns : Instance de FolderTrackingCustomization.
     */
    public static from(other: any) {
        if (!!other) {
            const instance = new FolderTrackingCustomization();

            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.viewId = other.viewId;
            instance.title = other.title;
            instance.headerText = other.headerText;
            instance.footerText = other.footerText;
            instance.headerAttributes = [...other.headerAttributes];
            instance.footerAttributes = [...other.footerAttributes];
            instance.stepCustomizations = FolderTrackingStepCustomization.fromArray(other.stepCustomizations);

            return instance;
        } else {
            return null;
        }
    }
}
